<template>
    <div class="filters" :class="{'filters_mobile': $vuetify.breakpoint.xsOnly}">
        <v-menu
                v-model="modelMenu"
                offset-y
                :close-on-content-click="false"
                max-width="300"
        >
            <template v-slot:activator="{on}">
                <v-btn
                    small
                    color="secondary"
                    v-on="on"
                    class="filters__btn v-btn__light"
                    elevation="0"
                >
                    <span class="filters__items">
                      <span class="filters__srt">{{ $t(label) }}<template v-if="getLabel.length > 0">:</template></span>
                      <span
                        v-for="item in getLabel"
                        class="filters__srt"
                      >{{ item.label }}<template v-if="item.value">(<b>{{ item.value }}</b>)</template></span>
                    </span>
                </v-btn>
            </template>
            <v-card class="filters__menu">
                <slot name="default"></slot>
                <div class="d-flex justify-end">
                    <v-btn
                            @click="$emit('clear')"
                            class="mr-3"
                            color="primary"
                            :small="!isMobile"
                            elevation="0"
                    >{{ $t('msg.clear') }}</v-btn>
                    <v-btn
                            color="primary"
                            @click="close()"
                            :small="!isMobile"
                            elevation="0"
                    >{{ $t('msg.close') }}</v-btn>
                </div>
            </v-card>
        </v-menu>
    </div>
</template>

<script>
export default {
    props: {
        value: Object,
        boolSingles: {type: Array, default: () => []},
        name: {type: String, required: true},
        dictValue: {type: Object, default: () => {return {}}},
        doNotSaveFilters: {type: Array, default: () => []},
        notShowInLabel: {type: Array, default: () => []},
        label: {type: String, default: 'msg.filter'},
        doNotSave: {type: Boolean, default: false},
        url: {type: Boolean, default: false}
    },
    data() {
        return {
            localValue: this.value,
            modelMenu: false
        };
    },
    watch: {
        value: {
            handler(v) {
                this.saveFilters();
                this.localValue = v;
                this.setUrl();
            },
            deep: true
        },
        localValue: {
            handler(v) {
                this.$emit('input', v);
            },
            deep: true
        }
    },
    computed: {
        isMobile() {
            return this.$vuetify.breakpoint.smAndDown;
        },
        getLabel() {
          let ret = [];

          let setValue = (key, value) => {

            let _ret = {
              label: this.$t('filter.'+key),
              value: null,
            };

            if (value !== undefined) {

              if (this.dictValue[key] !== undefined && this.dictValue[key][value] !== undefined) {

                value = this.dictValue[key][value];

              } else if (this.dictValue[key] !== undefined && typeof this.dictValue[key] === 'function') {

                value = this.dictValue[key](value);
              }

              _ret.value = value;
            }

            return _ret;
          };

          for (let key in this.value) {

            if (this.notShowInLabel.indexOf(key) > -1) continue;

            switch (typeof this.value[key]) {
              case 'string':
                if (this.value[key] !== '') {
                  ret.push(setValue(key, this.value[key]));
                }
                break;
              case 'object':
                let value = this.value[key];
                let _ret = '';
                for (let _key in value) {
                  if (_ret !== '') _ret += ', ';
                  _ret += value[_key];
                }
                if (_ret !== '') {
                  ret.push(setValue(key, _ret));
                }
                break;
              case 'boolean':
                if (this.boolSingles.indexOf(key) >= 0) {
                  if (this.value[key] === true) {
                    ret.push(setValue(key));
                  }
                } else {
                  let val = this.value[key] ? this.$t('msg.yes') : this.$t('msg.no');
                  ret.push(setValue(key, val));
                }
                break;
              case 'number':
                ret.push(setValue(key, this.value[key]));
                break;
            }
          }

          return ret;
        },
    },
    methods: {
        loadFilters() {

            if (this.doNotSave) return;

            let f = localStorage.getItem('filter-'+this.name);
            if (f != null) {
                let filters = JSON.parse(f);

                for (let key in filters) {


                    if (this.doNotSaveFilters.indexOf(key) >= 0) {
                        continue;
                    }

                    this.localValue[key] = filters[key];
                }
            }
        },
        saveFilters() {

            if (this.doNotSave) return;

            let f = JSON.stringify(this.localValue);
            localStorage.setItem('filter-'+this.name, f);
        },
        close() {
            this.modelMenu = false;
        },
        setUrl() {
            if (!this.url) return;

            let query = {};

            for (let key in this.value) {
                let item = this.value[key];

                if (typeof item === 'string') {
                    query[key] = item;
                }
            }

            if (query !== {}) {
                this.$router.replace({name: this.$route.name, query})
                    .catch(() => {});
            }
        },
        getUrl() {
            if (!this.url) return;

            let query = this.$route.query;

            if (query === {}) return;

            for (let key in query) {
                let item = query[key];

                this.localValue[key] = item;
            }
        }
    },
    created() {
        this.loadFilters();
        this.getUrl();
    }
}
</script>

<style lang="scss">
    .filters {
        &.filters_mobile {
            .filters__btn {
                min-height: 40px;
            }
        }
    }
    .filters__menu {
        padding: 10px;

        .v-input {
            margin: 10px 0;

            &:first-child {
                margin-top: 0;
            }
            &:last-child {
                margin-bottom: 0;
            }
        }
    }
    .filters__btn {
        min-height: 28px;
        height: inherit !important;
        line-height: 20px;
        text-transform: none;
        font-weight: normal;
        white-space: normal;
        display: inline;
        padding-top: 5px !important;
        padding-bottom: 5px !important;
        padding-left: 8px !important;
        padding-right: 8px !important;
        text-align: left;
    }
    .filters__srt {
        padding: 4px 4px;
    }
    .filters__items {
        display: flex;
        flex-wrap: wrap;
    }
</style>